<template>
  <form ref="form" autocomplete="off" class="tf" @submit.prevent>
    <ValidationObserver ref="observer" v-slot="{}">
      <div class="tf-row">
        <span class="tf-label">Event</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="Title" ref="event_title">
          <input v-model="event_title" class="tf-input" :class="{ error: errors.length }" placeholder="Event title" @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="tf-row">
        <span class="tf-label" :class="errorClass">Where</span>
        <vuetify-google-autocomplete
          ref="event_where"
          v-model="event_address"
          id="map"
          placeholder="Search location..."
          v-on:inputChange="validate"
          v-on:keypress="onKeyPress"
          :enable-geolocation="true"
          v-on:placechanged="getAddressEventData"
          :country="countrySelected"
          class="tf-input address-type-event"
        />
      </div>
      <div class="tf-grid">
        <div class="tf-row" style="flex: 2">
          <span class="tf-label">Starts</span>
          <ValidationProvider v-slot="{ errors }" rules="required" name="dateStart" ref="event_dateStart">
            <input type="date" v-model="event_dateStart" :min="nowDate" class="tf-input" :class="{ error: errors.length }" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Time</span>
          <ValidationProvider v-slot="{ errors }" rules="required" name="timeStart" ref="event_timeStart">
            <input type="time" v-model="event_timeStart" class="tf-input" :class="{ error: errors.length }" @change="addTimeFormat()" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
      </div>
      <div class="tf-grid">
        <div class="tf-row" style="flex: 2">
          <span class="tf-label">Ends</span>
          <ValidationProvider v-slot="{ errors }" rules="required" name="dateEnd" ref="event_dateEnd">
            <input type="date" v-model="event_dateEnd" :min="nowDate" class="tf-input" :class="{ error: errors.length }" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
        <div class="tf-row" style="flex: 1">
          <span class="tf-label">Time</span>
          <ValidationProvider v-slot="{ errors }" rules="required" name="timeEnd" ref="event_timeEnd">
            <input type="time" v-model="event_timeEnd" class="tf-input" :class="{ error: errors.length }" @change="addTimeFormat()" @keypress="onKeyPress"/>
          </ValidationProvider>
        </div>
      </div>
      <div class="tf-row">
        <span class="tf-label">Notes</span>
        <ValidationProvider v-slot="{ errors }" rules="required" name="notes" ref="event_notes">
          <input v-model="event_notes" class="tf-input" :class="{ error: errors.length }" placeholder="Add notes..." @keypress="onKeyPress"/>
          <span v-if="errors.length" class="tf-error">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </ValidationObserver>
  </form>
</template>
<script>
  import VuetifyGoogleAutocomplete from 'vue-google-autocomplete';
  import {ValidationObserver, ValidationProvider} from 'vee-validate'
  import moment from "moment";

  export default {
    props: {
      chat_id: {
        type: String,
        default: ""
      },
      message_send: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: Object,
        default: null
      },
      countrySelected: {
        type: Array,
        default: () => ["ca", "us"]
      }
    },
    components: {
      VuetifyGoogleAutocomplete,
      ValidationProvider,
      ValidationObserver,
    },
    data: () => ({
      minTimeStart: null,
      event_timeStart_formatted: "",
      event_timeEnd_formatted: "",
      nowDate: new Date().toISOString().slice(0, 10),
      event_title: null,
      event_where: null,
      event_address: null,
      addressG: null,
      isValidAddress: false,
      errorClass: '',
      event_dateStart: null,
      event_dateEnd: null,
      event_timeStart: null,
      event_timeEnd: null,
      event_notes: null,
      menuStart: false,
      menuEnd: false,
      menuTimeStart: false,
      menuTimeEnd: false,
      v: {
        title: null,
        dateStart: null,
        dateEnd: null,
        timeStart: null,
        timeEnd: null,
        notes: null,
      },

    }),
    watch: {
      async event_title() {
        const self = this;
        self.v.title = await self.$refs.event_title.validate();
        self.v.title = self.v.title.valid;
        self.validate_inputs();
      },
      async event_address() {
        const self = this;
        (self.isValidAddress) ? self.errorClass = '' : self.errorClass = 'error--text';
        self.validate_inputs();
      },
      async event_dateStart() {
        const self = this;
        self.v.dateStart = await self.$refs.event_dateStart.validate();
        self.v.dateStart = self.v.dateStart.valid;
        self.validate_inputs();
      },
      async event_dateEnd() {
        const self = this;
        self.v.dateEnd = await self.$refs.event_dateEnd.validate();
        self.v.dateEnd = self.v.dateEnd.valid;
        self.validate_inputs();
      },
      async event_timeStart() {
        const self = this;
        self.v.timeStart = await self.$refs.event_timeStart.validate();
        self.v.timeStart = self.v.timeStart.valid;
        if (self.event_timeStart) {
          const hour = (parseInt(self.event_timeStart.split(':')[0]) + 1) % 24;
          self.minTimeStart = (hour < 10 ? '0' : '') + hour + ':' + self.event_timeStart.split(':')[1];
        }
        self.validate_inputs();
      },
      async event_timeEnd() {
        const self = this;
        self.v.timeEnd = await self.$refs.event_timeEnd.validate();
        self.v.timeEnd = self.v.timeEnd.valid;
        self.validate_inputs();
      },
      async event_notes() {
        const self = this;
        self.v.notes = await self.$refs.event_notes.validate();
        self.v.notes = self.v.notes.valid;
        self.validate_inputs();
      },
      message_send(update) {
        const self = this;
        if (update) {
          self.event_title = null;
          self.event_address = null;
          self.event_dateStart = null;
          self.event_dateEnd = null;
          self.event_timeStart = null;
          self.event_timeEnd = null;
          self.event_notes = null;
          self.event_timeStart_formatted = "";
          self.event_timeEnd_formatted = "";
          self.isValidAddress = false;
          self.errorClass = '';
          if (self.$refs.event_where) self.$refs.event_where.clear();
        }
      },
      defaultValue: {
        handler(val) {
          if (val && Object.keys(val).length > 0) {
            this.event_title = val.event.title;
          }
        },
        deep: true
      }

    },
    created() {
      if (this.defaultValue && Object.keys(this.defaultValue).length > 0) {
        this.event_title = this.defaultValue.event.title;
        this.addressG = this.event_address = this.defaultValue.event.address;
        this.event_dateStart = moment(this.defaultValue.event.start_date).format("YYYY-MM-DD");
        this.event_dateEnd = moment(this.defaultValue.event.end_date).format("YYYY-MM-DD");
        this.event_timeStart = moment(this.defaultValue.event.start_date).format("HH:mm");
        this.event_timeStart_formatted = moment(this.defaultValue.event.start_date).format("hh:mm A");
        this.event_timeEnd = moment(this.defaultValue.event.end_date).format("HH:mm");
        this.event_timeEnd_formatted = moment(this.defaultValue.event.end_date).format("hh:mm A");
        this.event_where = {};
        this.event_where.address = this.defaultValue.event.address;
        this.event_where.latitude = this.defaultValue.event.latitude;
        this.event_where.longitude = this.defaultValue.event.longitude;
        this.event_notes = this.defaultValue.event.notes;

        this.isValidAddress = true;
        this.v.title = true;
        this.v.dateStart = true;
        this.v.dateEnd = true;
        this.v.timeStart = true;
        this.v.timeEnd = true;
        this.v.notes = true;
        this.validate_inputs();

        this.setter(true);
      }
    },
    methods: {
      addTimeFormat() {
        const self = this;
        if (self.event_timeStart) {
          let hour = parseInt(self.event_timeStart.split(":")[0]);
          let min = self.event_timeStart.split(":")[1];
          if (hour === 0) {
            self.event_timeStart_formatted = "12:" + min + " AM";
          } else if (hour < 12) {
            self.event_timeStart_formatted = (hour < 10 ? '0' : '') + hour + ":" + min + " AM";
          } else if (hour === 12) {
            self.event_timeStart_formatted = "12:" + min + " PM";
          } else {
            self.event_timeStart_formatted = ((hour - 12) < 10 ? '0' : '') + (hour - 12) + ':' + min + " PM";
          }
        }

        if (self.event_timeEnd) {
          let hour = parseInt(self.event_timeEnd.split(":")[0]);
          let min = self.event_timeEnd.split(":")[1];
          if (hour === 0) {
            self.event_timeEnd_formatted = "12:" + min + " AM";
          } else if (hour < 12) {
            self.event_timeEnd_formatted = (hour < 10 ? '0' : '') + hour + ":" + min + " AM";
          } else if (hour === 12) {
            self.event_timeEnd_formatted = "12:" + min + " PM";
          } else {
            self.event_timeEnd_formatted = ((hour - 12) < 10 ? '0' : '') + (hour - 12) + ':' + min + " PM";
          }
        }
      },

      async onKeyPress(event) {
        const self = this;
        if (event && event.key === "Enter") {
          self.$emit("pressEnter");
        }
      },

      getAddressEventData: function (addressData, placeResultData) {
        const self = this;
        if (addressData && placeResultData) {
          self.isValidAddress = true;
          self.errorClass = '';
          self.addressG = document.getElementById('map').value;
          self.event_where = {
            address: placeResultData.formatted_address,
            latitude: addressData.latitude,
            longitude: addressData.longitude,
            url: placeResultData.url
          };
        }
      },
      setter(isValid) {
        const self = this;
        var param = {
          type: 'event',
          message: {
            chat_id: self.chat_id,
            title: self.event_title,
            address: (self.isValidAddress) ? self.event_where.address : null,
            latitude: (self.isValidAddress) ? self.event_where.latitude : null,
            longitude: (self.isValidAddress) ? self.event_where.longitude : null,
            start_date: new Date(self.event_dateStart + " " + self.event_timeStart),
            end_date: new Date(self.event_dateEnd + " " + self.event_timeEnd),
            notes: self.event_notes,
            type: 'event',
          },
          isValid: isValid,
        };

        self.$emit("setter", param);
      },

      validate() {
        const self = this;

        if (self.addressG !== document.getElementById('map').value) {
          self.isValidAddress = false;
          self.errorClass = 'error--text';
          self.event_where = null;
        }
        if (!self.isValidAddress) {
          this.event_address = document.getElementById('map').value;
        }
      },
      async validate_inputs() {
        const self = this;
        var isValid = false;
        if (self.v.title && self.v.dateStart && self.v.dateEnd && self.v.timeStart && self.v.timeEnd && self.v.notes) {
          isValid = true;
        }

        (isValid && self.isValidAddress) ? self.setter(true) : self.setter(false);
      },
    },

  }
</script>
<style scoped lang="scss">
@import '../_variables';

.tf {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  > span { display: flex; flex-direction: column; gap: 6px; }
}

.tf-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  span { display: block; }
}

.tf-grid {
  display: flex;
  gap: 8px;
}

.tf-label {
  font-size: 10px;
  font-weight: 600;
  color: $t3;
  font-family: $font;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  &.error--text { color: #ff3b30; }
}

.tf-input {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none;
  transition: border-color 0.15s;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent; }
  &.error { border-color: #ff3b30; }
}

input[type="date"],
input[type="time"] {
  cursor: pointer;
  &::-webkit-calendar-picker-indicator {
    opacity: 0.4;
    cursor: pointer;
  }
}

.tf-error {
  font-size: 10px;
  color: #ff3b30;
  font-family: $font;
}

// Google autocomplete input override
::v-deep .vue-google-autocomplete {
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid $border !important;
  border-radius: 6px;
  background: #fff;
  font-size: 11px;
  font-family: $font;
  color: $t1;
  outline: none !important;
  box-shadow: none !important;
  &::placeholder { color: $t4; }
  &:focus { border-color: $accent !important; }
}

@media (max-width: 480px) {
  .tf { padding: 5px 8px; gap: 4px; > span { gap: 4px; } }
  .tf-label { font-size: 8px; }
  .tf-input { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
  .tf-grid { gap: 4px; }
  .tf-error { font-size: 8px; }
  ::v-deep .vue-google-autocomplete { height: 24px; font-size: 10px; padding: 0 6px; border-radius: 5px; }
}
@media (max-width: 360px) {
  .tf { padding: 3px 5px; gap: 3px; > span { gap: 3px; } }
  .tf-label { font-size: 7px; }
  .tf-input { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
  .tf-grid { gap: 3px; }
  .tf-error { font-size: 7px; }
  ::v-deep .vue-google-autocomplete { height: 20px; font-size: 9px; padding: 0 4px; border-radius: 4px; }
}
@media (max-width: 280px) {
  .tf { padding: 2px 3px; gap: 2px; > span { gap: 2px; } }
  .tf-label { font-size: 6px; }
  .tf-input { height: 18px; font-size: 8px; padding: 0 3px; }
  ::v-deep .vue-google-autocomplete { height: 18px; font-size: 8px; padding: 0 3px; }
}
</style>
